import useTranslation from 'next-translate/useTranslation';
import NextImage from 'next/image';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import styled from 'styled-components';

import CardOutlined from '@/components/CardOutlined';
import Text from '@/components/Text';
import useAuth from '@/hooks/useAuth';

const MyCardOutlined = styled(CardOutlined)`
  border: 1px solid #ebebeb;
  box-shadow: none;
  margin-bottom: 1.25rem;
  padding: 0;
  cursor: pointer;
  @media (max-width: 1000px) {
    max-width: 525px;
  }
`;

const ConsultationQuery = ({ setCurrentPage }) => {
  const { t: h } = useTranslation('page-auth');
  const consultationQuery = h('consultationQuery', {}, { returnObjects: true });
  const { register } = useAuth();
  return (
    <>
      <Text mb={['2.5rem', '2.5rem', '2.5rem']} variant="headlineGrey">
        {h('title')}
      </Text>
      <Text variant="capsTitle">{consultationQuery.step}</Text>
      <Text mb={['2.063rem', '2.063rem', '2.063rem']} variant="bodyLightSmallNativ">
        {consultationQuery.text}
      </Text>
      <MyCardOutlined onClick={setCurrentPage('Consultation')}>
        <Flex flexDirection="row">
          <Flex flexDirection="column" minWidth={['78px', '78px', '78px']}>
            <div
              style={{
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
                height: '100px',
                overflow: 'hidden',
                width: '78px',
              }}
            >
              <NextImage
                alt={consultationQuery.consultation.image.alternativeText}
                height={100}
                layout="responsive"
                priority
                quality="100"
                src={consultationQuery.consultation.image.url}
                width={78}
              />
            </div>
          </Flex>
          <Flex flexDirection="column" mx={['1.25rem', '1.25rem', '1.25rem']}>
            <Text marginTop={['1.25rem', '1.25rem', '1.25rem']} variant="bodyBoldSmall">
              {consultationQuery.consultation.title}
            </Text>
            <Text color="primaryDisabled" variant="chipText">
              {consultationQuery.consultation.text}
            </Text>
          </Flex>
        </Flex>
      </MyCardOutlined>

      <MyCardOutlined onClick={() => register({ redirectUri: `${document.location.origin}/auth?page=Target` })}>
        <Flex flexDirection="row">
          <Flex flexDirection="column" minWidth={['78px', '78px', '78px']}>
            <div
              style={{
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
                height: '100px',
                overflow: 'hidden',
                width: '78px',
              }}
            >
              <NextImage
                alt={consultationQuery.registration.image.alternativeText}
                height={100}
                layout="responsive"
                priority
                quality="100"
                src={consultationQuery.registration.image.url}
                width={78}
              />
            </div>
          </Flex>
          <Flex flexDirection="column" mx={['1.25rem', '1.25rem', '1.25rem']}>
            <Text marginTop={['1.25rem', '1.25rem', '1.25rem']} variant="bodyBoldSmall">
              {consultationQuery.registration.title}
            </Text>
            <Text color="primaryDisabled" variant="chipText">
              {consultationQuery.registration.text}
            </Text>
          </Flex>
        </Flex>
      </MyCardOutlined>
    </>
  );
};

ConsultationQuery.propTypes = {
  setCurrentPage: PropTypes.string.isRequired,
};
export default ConsultationQuery;
